<template>
  <v-dialog
      :value="value"
      max-width="500"
      @click:outside="close"
  >
    <v-card>
      <v-card-title>
        承認却下
      </v-card-title>
      <v-card-text>
        <v-textarea
            v-model="rejectComment"
            label="コメント"
            outlined
        ></v-textarea>
      </v-card-text>
      <v-card-actions class="px-6">
        <v-spacer></v-spacer>
        <v-btn @click="close" depressed>キャンセル</v-btn>
        <v-btn @click="sendReject" color="primary">却下</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import {store} from "@/store";

export default {
  name: "RejectRequestConfirmationDialog",
  props: ['value', 'folderId', 'rejectType', 'report'],
  data(){
    return {
      rejectComment: ''
    }
  },

  methods: {
    close(){
      this.$emit('input');
    },
    sendReject(){
      const confirm = {
        title: '承認却下確認',
        content: '承認依頼を却下します。よろしいですか。',
        onAgree: () => {
          this.axios
              .post(`/api/report/request-confirmation/reject/${this.folderId}`,
                  {
                    comment: this.rejectComment.trim(),
                    type: this.rejectType,
                    updated_at: this.report.updated_at
                  })
              .then((response) => {
                store.showSuccessDialog('承認依頼を却下しました。');
                this.close();
                this.$emit('rejected', response.data);
              })
              .catch((error) => {
                store.showErrorDialog(error.response.data.message);
                if (error.response.status === 403){
                  this.$emit('updateOutdatedReport', error.response.data.report, error.response.data.report_pdf_pages);
                }
                this.$emit('input');
              });
        },
        onDisagree: () => {}
      }
      store.showConfirmDialog(confirm);
    }
  }
}
</script>

<style scoped>

</style>
